/*
 * CheckoutPage Messages
 *
 * This contains all the text for the CheckoutPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.CheckoutPage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Đặt hàng',
  },
  headerStep1: {
    id: `${scope}.headerStep1`,
    defaultMessage: 'Giỏ hàng',
  },
  headerStep2: {
    id: `${scope}.headerStep2`,
    defaultMessage: 'Giao hàng',
  },
  headerStep3: {
    id: `${scope}.headerStep3`,
    defaultMessage: 'Xác nhận đơn hàng',
  },
  headerStep4: {
    id: `${scope}.headerStep4`,
    defaultMessage: 'Đặt hàng thành công',
  },
  goToMart: {
    id: `${scope}.goToMart`,
    defaultMessage: 'Vào Chợ',
  },
  goToFavorites: {
    id: `${scope}.goToFavorites`,
    defaultMessage: 'Vào Yêu Thích',
  },
  emptyCart: {
    id: `${scope}.emptyCart`,
    defaultMessage: 'Giỏ hàng trống',
  },
  yourCartIsEmpty: {
    id: `${scope}.yourCartIsEmpty`,
    defaultMessage: 'Giỏ hàng trống!',
  },
  goBacktoMartPrompt: {
    id: `${scope}.goBacktoMartPrompt`,
    defaultMessage: 'Chúng tôi có rất nhiều sản phẩm trong chợ!',
  },
  gotoTodayOrders: {
    id: `${scope}.gotoTodayOrders`,
    defaultMessage: 'Xem đơn hàng hôm nay',
  },
  yourOrderSent: {
    id: `${scope}.yourOrderSent`,
    defaultMessage: 'Đơn hàng của bạn đã được gửi',
  },
  yourPendingApprovalOrderSent: {
    id: `${scope}.yourPendingApprovalOrderSent`,
    defaultMessage: 'Đơn hàng của bạn đã được tạo và đang chờ phê duyệt',
  },
  saveDeliveryNote: {
    id: `${scope}.saveDeliveryNote`,
    defaultMessage: 'Lưu vào ghi chú giao hàng',
  },
  writeYourNote: {
    id: `${scope}.writeYourNote`,
    defaultMessage: 'Viết ghi chú...',
  },
  underMOQMessage: {
    id: `${scope}.underMOQMessage`,
    defaultMessage: 'Không thể tạo đơn hàng dưới giá trị đơn hàng tối thiểu',
  },
  removeAllCartMessage: {
    id: `${scope}.removeAllCartMessage`,
    defaultMessage: 'Bạn có chắc muốn xoá hết sản phẩm trong giỏ hàng không?',
  },
  gotoPendingOrders: {
    id: `${scope}.gotoPendingOrders`,
    defaultMessage: 'Xem đơn hàng chờ duyệt',
  },
  exclusiveProduct: {
    id: `${scope}.exclusiveProduct`,
    defaultMessage: 'Sản phẩm không có sẵn',
  },
  temporarilyOutOfStock: {
    id: `${scope}.temporarilyOutOfStock`,
    defaultMessage: 'Tạm thời hết hàng',
  },
  removeCount: {
    id: `${scope}.removeCount`,
    defaultMessage: 'Xóa ({count})',
  },
  exclusiveProductMessage: {
    id: `${scope}.exclusiveProductMessage`,
    defaultMessage: 'Sản phẩm này được bán độc quyền cho doanh nghiệp.',
  },
  product: {
    id: `${scope}.product`,
    defaultMessage: ' sản phẩm',
  },
  products: {
    id: `${scope}.products`,
    defaultMessage: ' sản phẩm',
  },
  exclusive: {
    id: `${scope}.exclusive`,
    defaultMessage: 'Độc quyền',
  },
  outOfStock: {
    id: `${scope}.outOfStock`,
    defaultMessage: 'Hết hàng',
  },
  voucherAppliedMessage: {
    id: `${scope}.voucherAppliedMessage`,
    defaultMessage: 'Voucher đã được áp dụng',
  },
  voucherErrorMessage: {
    id: `${scope}.voucherErrorMessage`,
    defaultMessage: 'Không thể sử dụng ưu đãi mà bạn đã chọn.',
  },
  voucherErrorLink: {
    id: `${scope}.voucherErrorLink`,
    defaultMessage: 'Nhấn vào đây để xem chi tiết.',
  },
  voucherDiscountTotal: {
    id: `${scope}.voucherDiscountTotal`,
    defaultMessage: 'Bạn đã tiết kiệm {discount}!',
  },
  orderDisabled: {
    id: `${scope}.orderDisabled`,
    defaultMessage:
      'Tài khoản của bạn tạm thời bị chặn vì một vài lý do. Vui lòng liên hệ đến bộ phận chăm sóc khách hàng để được hỗ trợ và kích hoạt lại. Cám ơn!',
  },
  frequentlyBuyTogetherTitle: {
    id: `${scope}.frequentlyBuyTogetherTitle`,
    defaultMessage: 'Sản phẩm thường mua cùng',
  },
  earliestDeliveryTime: {
    id: `${scope}.earliestDeliveryTime`,
    defaultMessage: 'Giao sớm nhất:',
  },
  removeAll: {
    id: `${scope}.removeAll`,
    defaultMessage: 'Xóa tất cả',
  },
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'Đồng ý',
  },
  no: {
    id: `${scope}.no`,
    defaultMessage: 'Không',
  },
  backToCart: {
    id: `${scope}.backToCart`,
    defaultMessage: 'Quay lại giỏ hàng',
  },
  emptyCartDescription: {
    id: `${scope}.emptyCartDescription`,
    defaultMessage: 'Hãy vào chợ hoặc mục Yêu thích để thêm sản phẩm vào giỏ hàng.',
  },
  emptyCartDescriptionNonSignIn: {
    id: `${scope}.emptyCartDescriptionNonSignIn`,
    defaultMessage: 'Hãy vào chợ để thêm sản phẩm vào giỏ hàng.',
  },
  createAccountToOrder: {
    id: `${scope}.createAccountToOrder`,
    defaultMessage: 'Tạo tài khoản để hoàn tất đơn hàng',
  },
  createAccountToEnjoyMoreBenefitsDescription: {
    id: `${scope}.createAccountToEnjoyMoreBenefitsDescription`,
    defaultMessage: 'Đăng ký miễn phí để đặt hàng, theo dõi giao hàng và nhận ưu đãi B2B',
  },
  signup: {
    id: `${scope}.signup`,
    defaultMessage: 'Đăng ký',
  },
  removeAllProductsSuccess: {
    id: `${scope}.removeAllProductsSuccess`,
    defaultMessage: 'Đã xóa tất cả sản phẩm!',
  },
  goToHome: {
    id: `${scope}.goToHome`,
    defaultMessage: 'Về trang chủ',
  },
});
